import React from 'react';
import './home.css';
import { AboutMe } from './abt_me/abt_me';
import { Skills } from './skills/skills';
import { ProjectsOverview } from './projects_main/projects_main';
import { Experience } from './experience/experience';
import { Education } from './education/education';
import { Resume } from './resume/resume';
import { Header } from '../static/navbar/navbar';
import { Footer } from '../static/footer/footer';

const Home = () => {
  return (
    <div className="page-container">
      <Header />

      <main className="main-content">
        {/* ── HERO ── */}
        <section className="hero-section visible" id="Home">
          <div className="hero-frame">
            <div className="hero-corner tl"></div>
            <div className="hero-corner tr"></div>
            <div className="hero-corner bl"></div>
            <div className="hero-corner br"></div>

            <div className="hero-sys-label">PORTFOLIO_OS v2.0</div>

            <h1 className="hero-name">AMRINDER BHOGAL</h1>
            <div className="hero-title">Engineer</div>
            <div className="hero-subtitle">B.Eng. &mdash; University of Guelph</div>

            <div className="hero-divider"></div>

            <div className="hero-tagline">
              <span className="prompt">&gt;</span> Integrating technology with civil engineering
              <span className="cursor-blink">_</span>
            </div>
          </div>

          <div className="scroll-indicator">
            <span>SCROLL</span>
            <div className="scroll-arrow">&#9660;</div>
          </div>
        </section>

        {/* ── SECTIONS ── */}
        <AboutMe />
        <Skills />
        <Experience />
        <ProjectsOverview />
        <Education />
        <Resume />
      </main>

      <Footer />
    </div>
  );
};

export default Home;
